<template>
    <!-- sign in start -->
    <section class="authentication-form">
      <div class="innerpage-decor">
      </div>
      <div>
        <h2 class="title text-center"><router-link to="/"><img :src='"../../assets/images/efunding-logo.png"' alt="logo-brand"></router-link></h2>
        <!-- <p class="text-center">Email terverfikasi</p> -->
        <div class="card text-center">
          <h3 :class="textColor">{{ msg }}</h3>
          <a href='/login'>Masuk</a>
        </div>
      </div>
      <!--strat color change -->
      <!--end color change-->
    </section>
    <!-- sign in end-->
</template>

<script>
import User from '../../api/user'

export default {
  name: 'EmailVerified',
  data() {
    return {
      msg: '',
      textColor: ''
    }
  },
  created() {
    if (this.$route.query.token) {
      User.verify({token: this.$route.query.token})
      .then(res => {
        if (res.data.meta.code == 400) {
          let query = Object.assign({}, this.$route.query);
          delete query.token;
          this.$router.push({ query })
          this.msg = 'Verifikasi email telah kadaluarsa, Masuk untuk mengirim ulang verifikasi'
          this.textColor = 'text-danger'
        } else {
          let query = Object.assign({}, this.$route.query);
          delete query.token;
          this.$router.push({ query })
          this.msg = 'Verifikasi Berhasil'
        }



      })
    } else {
      this.$router.push('/login')
    }
  },
  // methods: {
  //   onTry() {
  //     User.verify({token: this.$route.query.token})
  //     .then(res => {
  //       if (res.data.meta.code == 400) {
  //         this.msg = 'Verifikasi email telah kadaluarsa, Masuk untuk mengirim ulang verifikasi'
  //       }
  //       this.msg = 'Verifikasi Berhasil'
  //     })
  //   }
  // }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/public/auth/EmailVerified.vue